const lightTheme = {
  name: "light",
  themeBg: "#f3f3f5",
  lightBgcolor: "#F3F3F5",
  primaryBg: "#ffffff",
  textboxBg: "#fff",
  btnBg: "#000",
  btnText: "#fff",
  blackText: "#000",
  whiteText: "#fff",
  lightText: "#404040",
  primaryTextcolor: "#000",
  successColor:'#005141',
  secondaryTextcolor: "#fff",
  placeholderColor: "#9F9F9F",
  infoColor: "#004A94",
  dangerColor: "#710000",
  insideShadow:
    "inset -3px -3px 4px rgba(255, 255, 255, 0.8), inset 2px 2px 2px rgba(0, 0, 0, 0.25)",
  outsideShadow:
    "-3px -3px 4px rgba(255, 255, 255, 0.8), 2px 2px 2px rgba(0, 0, 0, 0.25)",
  searchShadow:
    "-1px -10px 14px -6px #FFFFFF, 5px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  btnShadow: "1px 12px 8px -7px rgba(0, 0, 0, 0.22)",
  outlineShadow:
    "inset -5px -2px 7px -1px #FFFFFF, inset 3px 3px 4px -2px rgba(0, 0, 0, 0.19)",
  inputShadow:
    "inset -3px -3px 4px rgba(255, 255, 255, 0.8), inset 2px 2px 2px rgba(0, 0, 0, 0.25)",
  thumbShadow:
    "-5px -2px 7px -1px #FFFFFF, 3px 3px 4px -2px rgba(0, 0, 0, 0.19)",
  cardShadow:
    "-3px -3px 3px rgba(255, 255, 255, 0.47), 2px 2px 2px rgba(0, 0, 0, 0.25)",
  subscribeShadow:
    "-10px -9px 10px -6px #FFFFFF, 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  imgInsideShadow:
    "inset -10px -9px 10px -6px #FFFFFF, inset 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  headerShadow:
    "-1px -10px 14px -6px #FFFFFF, 5px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  imageShadow:
    "-1px 0px 10px -6px #FFFFFF, 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  dropShadow:
    "1px -9px 10px -6px #FFFFFF, 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  tabShadow:
    "-2px -10px 14px -6px #ffffff, 5px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  bevelShadow:
    "inset 1px -9px 10px -6px #FFFFFF, inset 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  borderSm: "0.5px solid #bababa",
  borderXs: "0.25px solid #bababa",
  border: "1px solid #bababa",
  noborder: "1px solid #bababa",
  dashedborder: "1px dashed #585858",
  borderPrimary: "1px solid #CDCDCD",
};
const darkTheme = {
  name: "dark",
  themeBg: "#4B4B4B",
  lightBgcolor: "#4B4B4B",
  primaryBg: "#2a2a2a",
  textboxBg: "#fff",
  btnBg: "#000",
  btnText: "#fff",
  blackText: "#000",
  whiteText: "#fff",
  lightText: "#404040",
  primaryTextcolor: "#fff",
  successColor:'#fff',
  secondaryTextcolor: "#000",
  placeholderColor: "#9F9F9F",
  infoColor: "#0fa0d9",
  dangerColor: "#ff3c00",
  insideShadow:
    "inset -3px -3px 4px #4B4B4B, inset 2px 2px 2px rgba(0, 0, 0, 0.25)",
  outsideShadow: "-3px -3px 4px #4B4B4B, 2px 2px 2px rgba(0, 0, 0, 0.25)",
  searchShadow:
    "2px 3px 4px rgba(0, 0, 0, 0.28), -3px -3px 4px rgba(113, 113, 113, 0.39)",
  btnShadow: "1px 12px 8px -7px rgba(0, 0, 0, 0.22)",
  inputShadow:
    "inset -3px -3px 4px rgba(255, 255, 255, 0.8), inset 2px 2px 2px rgba(0, 0, 0, 0.25)",
  outlineShadow:
    "inset 2px 3px 4px rgba(0, 0, 0, 0.28), inset -3px -3px 4px rgba(113, 113, 113, 0.39)",
  thumbShadow:
    "2px 3px 4px rgba(0, 0, 0, 0.28), -3px -3px 4px rgba(113, 113, 113, 0.39)",
  cardShadow:
    "-3px -3px 3px rgba(255, 255, 255, 0.47), 2px 2px 2px rgba(0, 0, 0, 0.25)",
  subscribeShadow:
    "2px 3px 4px rgba(0, 0, 0, 0.28), -3px -3px 4px rgba(113, 113, 113, 0.39)",
  imgInsideShadow:
    "inset 2px 3px 4px rgba(0, 0, 0, 0.28), inset -3px -3px 4px rgba(113, 113, 113, 0.39)",
  headerShadow:
    "2px 3px 4px rgba(0, 0, 0, 0.28), -3px -3px 4px rgba(113, 113, 113, 0.39)",
  imageShadow:
    "-1px 0px 10px -6px rgba(0, 0, 0, 0.28), 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  dropShadow:
    "1px -9px 10px -6px rgba(0, 0, 0, 0.28), 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  tabShadow:
    "2px 3px 4px rgba(0, 0, 0, 0.28), -3px -3px 4px rgba(113, 113, 113, 0.39)",
  bevelShadow:
    "inset 1px -9px 10px -6px rgba(0, 0, 0, 0.28), inset 6px 10px 12px -5px rgba(0, 0, 0, 0.19)",
  borderSm: "0.25px solid #bababa40",
  borderXs: "0.25px solid #bababa5c",
  border: "1px solid #555555",
  noborder: "1px solid transparent",
  dashedborder: "1px dashed #CDCDCD ",
  borderPrimary: "1px solid #CDCDCD",
};

const findTheme = (type) => {
  switch (type) {
    case "dark":
      return darkTheme;
    case "light":
      return lightTheme;
    default:
      return lightTheme;
  }
};
const themeChanger = (type) => {
  let theme = findTheme(type);
  if (typeof window !== "undefined") {
    Object.keys(theme).forEach((k) =>
      document.documentElement.style.setProperty(`--${k}`, theme[k])
    );
  }
};

export default themeChanger;
